import { type UUID } from '~/types/common';

import { type ListParsingCasesParams } from './useQueryParsingCases/types';

/**
 * Query key factory for parsing case (DNPv2 reparsing) queries.
 */
export const queryKeysParsingCase = {
  base: () => 'parsingCase' as const,
  get: (caseId: UUID | undefined) =>
    [queryKeysParsingCase.base(), 'detail', { caseId }] as const,
  getAll: (params: ListParsingCasesParams) =>
    [queryKeysParsingCase.base(), 'list', params] as const,
} as const;
